const labels =  {
    LBL_CREATE: 'Créer un nouveau',
    LBL_EMPTY_LIST: 'Liste vide',
    LBL_MY: 'Mes',
    LBL_LIST: '$module$',
    LBL_BY: 'par',
    LBL_OR: 'ou',
    LBL_RESOLVED: 'Résolu',
    LBL_ADD_COMMENT: 'Commentaire',
    LBL_TODAY: "Aujourd'hui",
    LBL_YESTERDAY: 'Hier',
    LBL_ATTACHED_FILES: 'Pièce(s) jointe(s)',
    LBL_FILE_SIZE_EXCEEDED: 'Le fichier est trop volumineux ({{filesize}}MB).\nTaille maximale du fichier: {{maxFilesize}}MB',
    LBL_MAX_FILES_EXCEEDED: 'Vous ne pouvez plus télécharger de fichiers',

    LBL_LOGIN_TITLE: 'Espace client',
    LBL_USERNAME: 'Courriel',
    LBL_PASSWORD: 'Mot de passe',
    LBL_UNKNOWN: 'Inconnu',
    LBL_RESET_PASSWORD_TITLE: 'Mot de passe oublié ?',
    LBL_RESET_PASSWORD_TEXT: 'Remplissez le formulaire ci-dessous et nous vous enverrons par email les informations nécessaires pour accéder à votre compte.',
    LBL_EMAIL_ADDRESS: 'Adresse email',
    LBL_GOTO_LOGIN_PAGE: 'Aller à la page de connexion',
    LBL_EXPORT: 'Exporter mes données',
    LBL_FORGET_ME: 'Supprimer mes données',
    LBL_SAVE: 'Enregistrer',
    LBL_CONSENTS_MANAGER: 'Gestion des consentements',
    LBL_PERSONNEL_CONSENTS_DATA: 'Modifier mes données personnelles',
    LBL_FORGET_ME_CONFIRM: 'Oui, anonymiser mes données !',
    LBL_CANCEL: 'Annuler',
    LBL_REQUEST_ACCESS_TITLE: "Créer un compte",

    LBL_LOGIN_ERROR: 'Identifiant ou mot de passe invalide',

    LBL_RESET_PASSWORD_DONE: 'Les paramètres de connexion ont bien été envoyés à votre email',
    LBL_SAVE_DONE: 'Les modifications ont été effectuées',
    LBL_EXPORT_DONE: "L'export des données est en cours, vous allez recevoir le lien de téléchargement par email",
    LBL_REQUEST_ACCESS_DONE: 'Votre demande a bien été prise en compte',
    LBL_ARE_YOU_SURE: 'Êtes-vous certain ?',
    LBL_FORGET_ME_TEXT: 'Toutes vos donées seront remplacées par des données anonymes !',
    LBL_DOWNLOAD_IN_PROGRESS: 'Téléchargement en cours...',
    LBL_PORTAL_ACCESS_REFUSED: 'Accès au portail refusé !',
    LBL_EMAIL_IS_NOT_REGISTERED: "L'email n'est pas enregistré !",
    LBL_SYSTEM_ERROR: 'Opération non autorisée',
    LBL_CREDENTIALS_ALREADY_EXIST: 'Email déjà enregistré',

    LBL_GDPR_PORTAL: 'Portail RGPD',
    LBL_CLIENT_PORTAL: 'Portail Client',
    LBL_LOGIN_PAGE: 'Connexion',
    LBL_PASSWORD_RECOVERY_PAGE: 'Réintialiser mot de passe',
    LBL_HOME_PAGE: "Page d'accueil",
    LBL_DOWNLOAD_PAGE: 'Téléchargement des données',
    LBL_REQUEST_ACCESS_PAGE: "Création de compte sur le portail",

    LBL_CLOSE_HELPDESK: 'Fermer ce ticket',
    LBL_OPEN_HELPDESK: 'Ouvrir ce ticket',
    LBL_COMMENTED_BY: 'Commenté par',
    LBL_TYPE_A_COMMENT: 'Ajouter un commentaire...',
    LBL_DROP_FILE_TO_UPLOAD: 'Cliquez ici ou déposez ici des fichiers pour les envoyer',
    LBL_SEND_COMMENT: 'Envoyer',
    LBL_COMMENTS: 'Commentaires',
    LBL_SUBMIT_TICKET: 'Déposer votre demande',
    LBL_YOU: 'vous',

    LBL_HELPDESK_OPEN_DATE_DAYS: 'Ouvert il y a $days$j',
    LBL_HELPDESK_OPEN_DATE_HOURS: 'Ouvert il y a $hours$h',
    LBL_HELPDESK_OPEN_DATE_HOURS_MINUTES: 'Ouvert il y a $hours$h:$minutes$',
    LBL_HELPDESK_OPEN_DATE_MINUTES: 'Ouvert il y a $minutes$m',
    LBL_MAIN_BUTTON: 'Ticket', // Il y a un point ajouté à la fin du bouton qui ne devrait pas être ajouté
    LBL_SEARCH_PLACEHOLDER : 'Rechercher des tickets, des documents ou des factures',
    LBL_FILTER_BY: 'Filtrer par',
    LBL_REPORTER: 'Rapporteur',
    LBL_HELPDESK_TICKET_NUM: 'Ticket N°',
    LBL_HELPDESK_OPENED_DATE: 'Ouvert le',
    LBL_HELPDESK_ASSIGNED_TO: 'Assigné à',
    LBL_HELPDESK_HANDLED_BY: 'Traité par',
    LBL_HELPDESK_DESCRIPTION_TITLE: 'Description de la demande',
    LBL_HELPDESK_SEND_MESSAGE: 'Envoyez un message au support',
    LBL_HELPDESK_CREATED_FROM_COMPANY_MEMBER : "quelqu'un de chez ",
    LBL_CREATE_A_TICKET: 'Créer un ticket',
    LBL_HELPDESK_RESOLVE_ALERT_TITLE: 'Voulez-vous fermer ce ticket ?',
    LBL_HELPDESK_RESOLVE_ALERT_DESCRIPTION: 'Le ticket sera marqué comme fermé et vous ne pourrez plus envoyer de message concernant ce ticket et le service client considérera que la demande est traitée et terminée.',
    LBL_HELPDESK_MARK_AS_RESOLVED: 'MARQUER COMME RÉSOLU',
    LBL_HELPDESK_TYPE: 'Type',

    LBL_GDPR_PAGE_TITLE: 'GDPR - Gérer vos données personnelles',
    LBL_GDPR_DOWNLOAD_MY_DATA: 'Télécharger mes données',
    LBL_GDPR_DELETE_MY_DATA: 'Effacer mes données',
    LBL_GDPR_CONTACT_US: 'Contacter notre dpo',
    LBL_GDPR_CONTACT_NO: 'Contact #',
    LBL_GDPR_CREATION_DATE: 'Date de création',
    LBL_GDPR_CONTACT_ORIGIN: 'Origine du contact',
    LBL_GDPR_PORTABILITY_RIGHT: 'Droit à la portabilité des données',
    LBL_GDPR_GDPR_FORGOTTEN_RIGHT: 'Le droit d\'être oublié',
    LBL_GDPR_MORE_INFO: 'Pour plus d\'informations',

    LBL_PAID: 'Payé :',
    LBL_DUE: 'Échéance :',
    LBL_DOWNLOAD: 'Télécharger',
    LBL_LOADING: 'Chargement...',

    LBL_MORE: 'Plus',
    LBL_YES: 'Oui',
    LBL_NO: 'Non',

    LBL_QUOTE_TITLE: 'Votre devis',
    LBL_QUOTE_DOWNLOAD_PDF: 'Télécharger PDF',
    LBL_QUOTE_OPEN_PDF: 'Ouvrir le PDF',
    LBL_QUOTE_SEND_FEEDBACK: 'Envoyer un retour',
    LBL_QUOTE_CONTACT: 'Votre contact',
    LBL_QUOTE_LAST_UPDATE: 'Dernière modification',
    LBL_QUOTE_QUOTE_NO: 'devis n°',
    LBL_QUOTE_VALID_TILL: "Valable jusqu'au",
    LBL_QUOTE_CREATE_WITH: 'Devis créé avec',
    LBL_QUOTE_ERROR: "Le devis que vous souhaitez visualiser n'est pas disponible, il a peut-être été supprimé ou le lien n'est pas valide. N'hésitez pas à contacter votre commercial, ou réessayez ultérieurement." ,
    LBL_INVOICES: 'Factures',

    LBL_CONTINUE: 'Continuer',
    LBL_ONLINE: 'en ligne',
    LBL_ON: 'le',
    LBL_FIRST_NAME: 'Prénom',
    LBL_LAST_NAME: 'Nom',
    LBL_EMAIL: 'Email',
    LBL_CELL_PHONE: 'Téléphone portable',

    // Esign
    LBL_DOCUMENT_WAS_SIGNED: 'Ce document a été signé',
    LBL_USING_THE_PHONE: 'avec le téléphone',
    LBL_ACCEPT_AND_SIGN_QUOTE: 'Accepter et signer le devis',
    LBL_SIGNATORY_FORM_GUIDE: 'Entrez vos coordonnées pour procéder à la signature électronique',
}

export default labels
